import Swal from "sweetalert2";
import inMemoryJwt from "../../auth/inMemoryJwt";
import { urlServer } from "../../config/GlobalConstant";
import {
  CREATE_WINERY_BATCHES,
  DELETE_WINERY_BATCHES,
  ERROR_WINERY_BATCHES,
  IS_WINERY_BATCHES,
  LIST_OF_WINERY_BATCHES,
} from "./types";
const toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
});

export const createBatch = (batch, formRef) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_WINERY_BATCHES,
  });
  await fetch(`${urlServer}mainproductbatches/create`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      // 'Content-Type': 'application/x-www-form-urlencoded',
      "Content-Type": "application/json",
    }, // body data type must match "Content-Type" header
    body: JSON.stringify(batch),
  })
    .then((response) => response.json())
    .then((respJson) => {
      console.log();
      if (respJson.success) {
        formRef.current.resetForm();
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: CREATE_WINERY_BATCHES,
          payload: respJson.data,
        });
      } else {
        toast.fire({
          title: "error",
          icon: "error",
        });
        dispatch({
          type: ERROR_WINERY_BATCHES,
        });
      }
    });
};
export const deleteBatch = (values) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index 61b234836a1bb35e7dd4bd8d
    type: IS_WINERY_BATCHES,
  });
  await fetch(`${urlServer}mainproductbatches/delete`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    }, // body data type must match "Content-Type" header
    body: JSON.stringify(values),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.success) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: DELETE_WINERY_BATCHES,
          payload: {
            id: values.batchId,
            quantityDeleted: values.quantityDeleted,
          },
        });
      } else {
        dispatch({
          type: ERROR_WINERY_BATCHES,
        });
      }
    });
};

export const seeWineryBatches = (limit, skip) => async (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_WINERY_BATCHES,
  });
  await fetch(`${urlServer}mainproductbatches/get-created`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
    },
    body: JSON.stringify({
      limit,
      skip,
    }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.data.length > 0) {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_WINERY_BATCHES,
          payload: { data: respJson.data, skip, hasMore: true },
        });
      } else {
        dispatch({
          type: LIST_OF_WINERY_BATCHES,
          payload: { data: [], skip, hasMore: false },
        });
      }
    });
};
export const getBatchesByProductAndLocation =
  (productId, locationId) => async (dispatch) => {
    console.log();
    //This method required locationID from winery/subwinery or Warehouse and productID
    dispatch({
      //Esto se lo envía a combineReducer, el que está en el index
      type: IS_WINERY_BATCHES,
    });
    await fetch(`${urlServer}mainproductbatches/get-by-location-product`, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: `bearer ${inMemoryJwt.getToken()}`,
        "Content-Type": "application/json",
      }, // body data type must match "Content-Type" header
      body: JSON.stringify({ productId, locationId }),
    })
      .then((response) => response.json())
      .then((respJson) => {
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_WINERY_BATCHES,
          payload: respJson.data.batches,
        });
      })
      .catch((error) => {
        console.log();
      });
  };
export const clearBatchesByProduct = () => (dispatch) => {
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: "CLEAR_OF_WINERY_BATCHES",
  });
};
export const getBatchesByProduct = (productId) => async (dispatch) => {
  //This method required locationID from winery/subwinery or Warehouse and productID
  dispatch({
    //Esto se lo envía a combineReducer, el que está en el index
    type: IS_WINERY_BATCHES,
  });
  await fetch(`${urlServer}mainproductbatches/get-by-product`, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    withCredentials: true,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${inMemoryJwt.getToken()}`,
    }, // body data type must match "Content-Type" header
    body: JSON.stringify({ productId }),
  })
    .then((response) => response.json())
    .then((respJson) => {
      if (respJson.data.length > 0) {
        console.log()
        dispatch({
          //Esto se lo envía a combineReducer, el que está en el index
          type: LIST_OF_WINERY_BATCHES,
          payload: {data: respJson.data, hasMore: true}
        });
      } else {
        dispatch({
          type: LIST_OF_WINERY_BATCHES,
          payload: { data: [], hasMore: false },
        });
      }
      
    })
    .catch((error) => {
      console.log();
    });
};
